import { ExplorerBreadcrumbs, ExplorerItems } from "@/types/types.ts";
import fetchInstance from "@/services/fetch.ts";
import { encodeURIPath } from "next/dist/shared/lib/encode-uri-path";

export async function fetchSearchExplorerItems(searchTerm: string): Promise<ExplorerItems> {
  try {
    return fetchInstance.get(`/explorer/search/${encodeURIPath(searchTerm)}`).then(e => e.json());
  } catch (error) {
    console.log("Fout bij het zoeken:", error)

    throw error;
  }
}

export async function fetchRootExplorerItems(params?: {
  bandWorkspaceId?: number | null,
  offset?: number,
  limit?: number,
}): Promise<ExplorerItems> {
  const {
    bandWorkspaceId,
    offset,
    limit,
  } = params as { bandWorkspaceId: number | null, offset: number, limit: number }
  try {
    const response = await fetchInstance.get(`/explorer-root-items/${bandWorkspaceId}/${offset || 0}/${limit || 100}`)
    return (await response.json()) || [];
  } catch (error) {
    console.log("Fout bij fetchRootExplorerItems:", error)

    throw error;
  }
}

export async function fetchExplorerItems(params: {
  folderId?: string | null,
  offset?: number,
  limit?: number,
  bandWorkspaceId?: number | null,
}): Promise<ExplorerItems> {
  const {
    folderId,
    offset,
    limit,
    bandWorkspaceId,
  } = params
  try {
    const response = await fetchInstance.get(`/explorer/${bandWorkspaceId}/folder/${folderId}/${offset || 0}/${limit || 100}`)

    return await response.json()
  } catch (error) {
    console.log("Fout bij fetchExplorerItems:", error)

    throw error;
  }
}

export async function fetchExplorerBreadcrumbs(folderId: string): Promise<ExplorerBreadcrumbs> {
  try {
    const response = await fetchInstance.get(`/explorer/breadcrumbs/${folderId}`)
    return (await response.json()) || [];
  } catch (error) {
    console.log("Fout bij fetchExplorerBreadcrumbs:", error)

    throw error;
  }
}

export async function createAudioTrack(params: {
  userId: string,
  explorerItemId: string,
  name: string,
  filePath: string,
  mimeType: string,
  startTime: number,
  offsetLeft: number,
  duration: number,
  sampleRate: number,
  channelCount: number,
  fileSize: number,
}) {
  return await fetchInstance
    .post(
      `/audio-track/create`,
      params,
    );
}

export async function fetchAudioTrackByExplorerItemId(explorerItemId: string) {
  try {
    const response = await fetchInstance.get(`/audio-tracks/${explorerItemId}`)

    return response;
  } catch (error) {
    console.log("Fout bij fetchAudioTrackByExplorerItemId:", error)

    throw error;
  }
}

export async function updateAudioTrackStartTimeAndOffsetByFilePath(
  params: {
    filePath: string,
    startTime: number,
    offsetLeft: number,
  }
) {
  try {
    const response = await fetchInstance.put(`/audio-track/update-start-time-offset-by-file-path/${params.filePath}`, params)

    return response;
  } catch (error) {
    console.log("Fout bij updateAudioTrackStartTimeAndOffsetByFilePath:", error)

    throw error;
  }
}

export async function updateAudioTrackStartTimeAndOffset(
  params: {
    audioTrackId: number,
    startTime: number,
    offsetLeft: number,
  }
) {
  try {
    const response = await fetchInstance.put(`/audio-track/update-start-time-offset/${params.audioTrackId}`, params)

    return response;
  } catch (error) {
    console.log("Fout bij updateAudioTrackStartTimeAndOffset:", error)

    throw error;
  }
}

export async function fetchAudioTrackById(audioTrackId: number) {
  try {
    const response = await fetchInstance.get(`/audio-track/${audioTrackId}`)

    return response;
  } catch (error) {
    console.log("Fout bij fetchAudioTrackById:", error)

    throw error;
  }
}

export async function deleteAudioTrackByFilePath(filePath: string) {
  try {
    const response = await fetchInstance.delete(`/audio-track/delete-by-file-path/${filePath}`)

    return response;
  } catch (error) {
    console.log("Fout bij deleteAudioTrackByFilePath:", error)

    throw error;
  }
}

export async function deleteAudioTrackById(audioTrackId: number) {
  try {
    const response = await fetchInstance.delete(`/audio-track/${audioTrackId}`)

    return response;
  } catch (error) {
    console.log("Fout bij deleteAudioTrackById:", error)

    throw error;
  }
}

export async function updateAudioTrackVolumeByFilePath(
  params: {
    filePath: string,
    volume: number,
  }
) {
  try {
    const response = await fetchInstance.put(
      `/audio-track/update-volume/${params.filePath}`,
      params
    )

    return response;
  } catch (error) {
    console.log("Fout bij updateAudioTrackVolumeByFilePath:", error)

    throw error;
  }
}

export async function updateAudioTrackMutedByFilePath(
  params: {
    filePath: string,
    isMuted: boolean,
  }
) {
  try {
    const response = await fetchInstance.put(
      `/audio-track/toggle-mute/${params.filePath}`,
      params
    )

    return response;
  } catch (error) {
    console.log("Fout bij updateAudioTrackMuteByFilePath:", error)

    throw error;
  }
}

export async function updateAudioTrackSoloByFilePath(
  params: {
    filePath: string,
    isSolo: boolean,
  }
) {
  try {
    const response = await fetchInstance.put(
      `/audio-track/toggle-solo/${params.filePath}`,
      params
    )

    return response;
  } catch (error) {
    console.log("Fout bij updateAudioTrackSoloByFilePath:", error)

    throw error;
  }
}
